import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import { Observable, of as observableOf } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public authUser$: Observable<firebase.User | null> = observableOf(null);
  public userCredential$: Observable<firebase.auth.UserCredential | null> = observableOf(null);
  public isUserLoggedIn$: Observable<boolean> = observableOf(false);

  constructor(
    private readonly afAuth: AngularFireAuth,
    private readonly firestoreApp: FirebaseApp,
    @Inject(PLATFORM_ID) platformId: object,
    private readonly router: Router,
  ) {
    if (!isPlatformServer(platformId)) {
      this.authUser$ = this.afAuth.authState;
      this.userCredential$ = this.afAuth.credential;
      this.isUserLoggedIn$ = this.authUser$.pipe(map((user) => !!user));
    }
  }

  async signInWithGoogle(): Promise<firebase.auth.UserCredential> {
    return await this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  async signInAnonymously(): Promise<firebase.auth.UserCredential> {
    return this.afAuth.signInAnonymously();
  }

  async signOut() {
    this.afAuth.signOut();
    this.router.navigateByUrl('/login');
  }
}
